import moment from "moment";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import {
  apiGetServices,
  IApiGetServices,
} from "../../../../../api/service/apiGetServices";
import {
  SERVICE_STATE,
  TGetServicesCollectionItem,
} from "../../../../../api/service/service.types";

export default function useMyUnvaluedServicesQuery() {
  const authUser = useSelector((state: any) => state.auth.authUser);

  return useQuery(
    ["my_unvalued_services"],
    async () => {
      const params: IApiGetServices = {
        partial: 1,
        doNotLog: 1,
        owner: [authUser.userId],
        state: [SERVICE_STATE.WITHOUT_VALIDATION],
      };

      const res = await apiGetServices(params);
      const services = res["hydra:member"].filter(
        (service: TGetServicesCollectionItem) => {
          const now = moment();
          const delayedService = service.delayedDate;
          const delayedDate = delayedService ? moment(delayedService) : null;
          return !delayedDate || delayedDate.isBefore(now);
        }
      );
      return {
        unValuedServices: services,
        totalUnvaluedServices: services.length,
      };
    },
    {
      enabled: true,
      refetchInterval: 30000,
    }
  );
}
